import { render, staticRenderFns } from "./CancelTurn.vue?vue&type=template&id=2aa935b1&lang=pug&"
import script from "./CancelTurn.vue?vue&type=script&lang=js&"
export * from "./CancelTurn.vue?vue&type=script&lang=js&"
import style0 from "./CancelTurn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa935b1')) {
      api.createRecord('2aa935b1', component.options)
    } else {
      api.reload('2aa935b1', component.options)
    }
    module.hot.accept("./CancelTurn.vue?vue&type=template&id=2aa935b1&lang=pug&", function () {
      api.rerender('2aa935b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobileFSFB/CancelTurn.vue"
export default component.exports